import '../CsvJsonInfoPages.scss';


function PricePerMile() {

    const data = [
        { field: 1, description: 'CAP Vehicle Code' },
        { field: 2, description: 'CAP Vehicle Identification Number' },
        { field: 3, description: 'Unused' },
        { field: 4, description: 'Mileage' },
        { field: 5, description: 'Periods 1st Mileage Values' },
        { field: 6, description: 'Mileage' },
        { field: 7, description: 'Periods 2nd Mileage Values' },
        { field: 8, description: 'Mileage' },
        { field: 9, description: 'Periods 3rd Mileage Values' },
        { field: 10, description: 'Mileage' },
        { field: 11, description: 'Periods 4th Mileage Values' },
        { field: 12, description: 'Mileage' },
        { field: 13, description: 'Periods 5th Mileage Values' },
        { field: 14, description: 'Mileage 6' },
        { field: 15, description: 'Periods 6th Mileage Values' },
        { field: 16, description: 'Mileage 7' },
        { field: 17, description: 'Periods 7th Mileage Values' },
        { field: 18, description: 'Mileage 8' },
        { field: 19, description: 'Periods 8th Mileage Values' },
        { field: 20, description: 'Mileage 9' },
        { field: 21, description: 'Periods 9th Mileage Values' },
        { field: 22, description: 'Mileage 10' },
        { field: 23, description: 'Periods 10th Mileage Values' },
        { field: 24, description: 'Mileage 11' },
        { field: 25, description: 'Periods 11th Mileage Values' },
        { field: 26, description: 'Mileage 12' },
        { field: 27, description: 'Periods 12th Mileage Values' },
        { field: 28, description: 'Mileage 13' },
        { field: 29, description: 'Periods 13th Mileage Values' },
        { field: 30, description: 'Mileage 14' },
        { field: 31, description: 'Periods 14th Mileage Values' },
        { field: 32, description: 'Mileage 15' },
        { field: 33, description: 'Periods 15th Mileage Values' },
        { field: 34, description: 'Mileage 16' },
        { field: 35, description: 'Periods 16th Mileage Values' },
        { field: 36, description: 'Mileage 17' },
        { field: 37, description: 'Periods 17th Mileage Values' },
        { field: 38, description: 'Mileage 18' },
        { field: 39, description: 'Periods 18th Mileage Values' },
        { field: 40, description: 'Mileage 19' },
        { field: 41, description: 'Periods 19th Mileage Values' },
        { field: 42, description: 'Mileage 20' },
        { field: 43, description: 'Periods 20th Mileage Values' },
        { field: 44, description: 'Miles Per Gallon (####.####)' },
        { field: 45, description: 'EC = EC Combined, Blank = PCFCO 1983' },
    ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>Future Values - Price Per Mile</h1>
            <p>Provides a pence per mile value based on the Monitor residual value, Fuel use and Service Costs.
                <b>File Naming Convention</b>
                kCPRPPM.??? CARS ONLY<br />
                The 3 question marks (???) on each of the above files will be replaced with the month i.e. MAR for March.<br /><br />
                The 14 Periods Covered<br/>
                6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78 and 84 Months.<br/>
                NOTE : Not all of the periods may be used.
            </p>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

export default PricePerMile;
